module.exports = "/assets/data/c7618fc68bbb6b27040a9a5401cec34f-EN6.data.json";